import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const IdaLogoSvg = forwardRef((props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 75 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: /* @__PURE__ */ jsxs("g", { id: "logo", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      id: "Vector",
      d: "M69.8694 25.9958L56.7363 0.818704C56.3686 0.111864 55.3505 0.111864 54.9828 0.818704L41.8662 25.9985C41.4601 26.7788 42.0308 27.7113 42.9199 27.7113H43.3946C43.8392 27.7113 44.2453 27.4639 44.4483 27.0724L55.3368 6.03845C55.5563 5.61434 56.171 5.61163 56.3905 6.03845L67.2845 27.0724C67.4875 27.4639 67.8936 27.7113 68.3382 27.7113H68.8129C69.702 27.7113 70.2728 26.7788 69.8666 25.9985L69.8694 25.9958Z",
      "data-fill": true
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      id: "Vector_2",
      d: "M10.2271 0.378418H1.18544C0.530738 0.378418 0 0.904234 0 1.55286V26.5342C0 27.1828 0.530738 27.7087 1.18544 27.7087H10.2271C10.8818 27.7087 11.4126 27.1828 11.4126 26.5342V1.55286C11.4126 0.904234 10.8818 0.378418 10.2271 0.378418Z",
      "data-fill": true
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      id: "Vector_3",
      d: "M21.4751 4.83688C21.4751 5.48935 22.0102 6.01676 22.6688 6.01132H22.9843C28.2968 6.01132 31.8477 9.49659 31.8477 14.0312C31.8477 18.5659 28.2941 22.0838 23.0282 22.0838H22.6605C22.0074 22.0838 21.4751 22.6085 21.4751 23.2582V26.5206C21.4751 27.1676 22.0047 27.695 22.6605 27.695H23.5277C32.0041 27.695 37.9011 21.589 37.9011 14.0448C37.9011 6.50068 31.9327 0.383789 23.4398 0.383789H22.6605C22.0074 0.383789 21.4751 0.908482 21.4751 1.55823V4.8396V4.83688Z",
      "data-fill": true
    }
  )
] }) }));
export {
  IdaLogoSvg,
  IdaLogoSvg as default
};
